module.exports = __webpack_public_path__ + "media/images/svg/frowning-face-5529b2821d590cf1a09bf283b1624379.svg";